<div class='grid-wrapper' kbStickyAnchorContainer>
    <div class='title'>
        <h1 class='text-3xl font-bold tracking-tight text-gray-900'>
            {{ productPreview?.name }}
        </h1>
        <kb-brand-label [product]='product'></kb-brand-label>
        <kb-star-rating
            [rating]='productPreview?.customFields?.reviewRating || 0'
            [reviewCount]='productPreview?.customFields?.reviewCount || 0'
            reviewCountAnchor='reviews'
            class='block mb-4'
        ></kb-star-rating>
    </div>
    <div class='image'>
        <kb-asset-gallery
            kbStickyAnchor
            class="block"
            [assets]='product?.assets ?? []'
            [videoUrls]='product?.customFields.videoUrls'
            [selectedAssetId]='product?.featuredAsset?.id'
            [productName]='productPreview?.name'
        ></kb-asset-gallery>
    </div>
    <div class='description'>
        <kb-large-letter-label *ngIf="qualifiesForLetterboxService" />
        <kb-offer-label [product]='product'></kb-offer-label>
        <kb-product-accordion
            class="block my-4"
            [description]="productPreview.description"
            [keyFeatures]="productPreview.customFields.keyFeatures"
            [facetValues]="product?.facetValues"
            [variants]="filteredVariants$ | async"
        />
        <kb-shipping-info-label [shippingInfo]='shippingInfo$ | async'></kb-shipping-info-label>
    </div>
</div>
<div
    class='flex flex-col -mx-2 sm:mx-0 space-y-4 lg:space-y-0 lg:space-x-6 lg:flex-row justify-between text-xs sm:text-sm bg-gray-100 rounded lg:rounded-lg px-4 py-2 lg:py-6 my-10 sticky top-0 z-10'
>
    <div class='flex items-center space-x-4'>
        <ng-container *ngIf='formatOptionGroup as formatGroup'>
            <span class='font-medium'>Format:</span>
            <select
                [formControl]='selectedFormatOptionId'
                class='lg:hidden text-xs sm:text-sm mt-1 block pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 rounded-md'
            >
                <option *ngFor='let option of formatGroup.options' [value]='option.id'>
                    {{ option.name }}
                </option>
            </select>
            <span class='hidden lg:block relative z-0 inline-flex shadow-sm rounded-md'>
                <button
                    type='button'
                    *ngFor='let option of formatGroup.options; first as isFirst; last as isLast'
                    (click)='selectedFormatOptionId.setValue(option.id)'
                    [ngClass]="{
                        'btn-toggle-active': selectedFormatOptionId.value === option.id,
                        'rounded-l-md': isFirst,
                        '-ml-px': !isFirst,
                        'rounded-r-md': isLast
                    }"
                    class='btn btn-toggle inline-flex rounded-none px-3'
                >
                    <img [src]='option.icon' class='w-6 h-6 rounded mr-2'
                         [class.invert]='selectedFormatOptionId.value === option.id' />
                    {{ option.name }}
                </button>
            </span>
        </ng-container>
    </div>
    <div class='relative rounded-md shadow-sm flex-1'>
        <div class='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
            <fa-icon [icon]='filter' class='text-gray-200'></fa-icon>
        </div>
        <input
            type='text'
            name='filter'
            id='filter'
            class='focus:secondary-500 focus:border-secondary-500 text-xs sm:text-sm block w-full pl-10 border-gray-300 rounded-md'
            [formControl]='filterControl'
            placeholder='Filter by name or product code'
        />
    </div>

    <div class='flex items-baseline space-x-4'>
        <span class='font-medium'>Sort by:</span>
        <span class='relative z-0 inline-flex shadow-sm rounded-md'>
            <button
                type='button'
                *ngFor='let option of sortOptions; first as isFirst; last as isLast'
                (click)='sortControl.setValue(option)'
                [ngClass]="{
                    'btn-toggle-active': sortControl.value === option,
                    'rounded-l-md': isFirst,
                    '-ml-px': !isFirst,
                    'rounded-r-md': isLast
                }"
                class='btn btn-toggle inline-flex rounded-none px-3'
            >
                {{ option | uppercaseFirst }}
            </button>
        </span>
    </div>
</div>
<div class='relative'>
    <div *ngIf='!product' class='p-12 mx-auto rounded absolute w-full top-12'>
        <p class='text-2xl text-gray-500 animate-pulse text-center'>Loading...</p>
    </div>
    <div
        class='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-y-6 mt-2 min-h-75vh'
        *ngIf='processingIds$ | async as processingIds'
    >
        <div
            class='flex items-center flex-col'
            *ngFor='let variant of filteredVariants$ | async; trackBy: trackById; let i = index'
        >
            <div class='flex flex-col items-center'>
                <div
                    class='relative mx-auto cursor-pointer'
                    (click)='displayColorInfo(variant)'
                    title='Click for more info'
                >
                    <kb-picture
                        [w]='150'
                        [h]='75'
                        [focalPoint]='variant.featuredAsset?.focalPoint'
                        imgClass='rounded border border-gray-200'
                        [src]='variant.featuredAsset?.preview'
                        [alt]='variant.name'
                        [lazy]='12 < i'
                    ></kb-picture>
                    <div
                        *ngIf='inCartQty[variant?.id] as inCart'
                        class='text-green-700 absolute inset-0 flex items-center justify-center'
                    >
                        <div class='bg-green-50 border-green-400 bg-opacity-70 px-2 rounded'>
                            <fa-icon [icon]='check' size='xs'></fa-icon>
                            {{ inCart }} in cart
                        </div>
                    </div>
                </div>
                <div *ngIf='listOptions(variant) as title' class='w-full'>
                    <div class='text-sm text-center font-medium'>{{ title.name }}</div>
                    <div class='w-full' *ngIf='title.format'>
                        <span
                            class='text-xs text-center uppercase px-0.5 rounded-md border border-gray-200 bg-gray-50'
                        >{{ title.format }}</span
                        >
                    </div>
                    <div class='-my-1 flex w-full justify-between items-center'>
                        <div class='text-sm text-gray-500'>
                            {{ variant?.sku }}
                        </div>
                        <kb-add-to-wishlist-button
                            [showLabel]='false'
                            [inWishlists]='variantAppearsInWishlists(variant.id)'
                            [variantId]='variant.id'
                            (addClick)='addToWishList(variant.id, $event)'
                        >
                            <ng-template>
                                <button
                                    class='btn-icon px-2'
                                    [title]="
                                        variantAppearsInWishlists(variant.id)?.length || addedToWishlist[variant.id]
                                            ? 'In wishlist'
                                            : 'Add to wishlist'
                                    "
                                >
                                    <fa-icon
                                        [icon]="
                                            variantAppearsInWishlists(variant.id)?.length || addedToWishlist[variant.id] ?
                                               heartSolid : heart"
                                        size='xs'
                                    ></fa-icon>
                                </button>
                            </ng-template>
                        </kb-add-to-wishlist-button>
                    </div>
                </div>
                <div class='flex w-full justify-between items-baseline space-x-2'>
                    <div
                        class='text-sm opacity-70 font-medium text-red-700 line-through'
                        *ngIf='variant?.customFields.rrp as rrp'
                        title='RRP'
                    >
                        <span *ngIf='variant.priceWithTax < rrp'>
                            RRP {{ variant?.customFields.rrp | formatPrice }}
                        </span>
                    </div>
                    <div class='text-primary-800 font-medium relative'>
                        <span>{{ variant?.priceWithTax | formatPrice }}</span>
                    </div>
                </div>
                <kb-special-price-badge [selectedVariant]="variant" badgeClass="my-1"></kb-special-price-badge>
                <ng-container *ngIf='!inCartQty[variant?.id]; else inCartControls'>
                    <div class='w-full flex justify-between'>
                        <input
                            type='number'
                            min='0'
                            max='99'
                            placeholder='Qty'
                            value='1'
                            #qty
                            (input)='setQuantityForVariant(variant.id, $event)'
                            class='input w-16'
                        />
                        <div class=''>
                            <button
                                [disabled]="
                                    quantities[variant.id] == 0 ||
                                    variant.stockLevel === 'OUT_OF_STOCK' ||
                                    processingIds.includes(variant.id)
                                "
                                class='btn btn-primary px-4 relative flex items-center justify-center'
                                (click)='addToCart(variant.id, +qty.value)'
                            >
                                Add
                                @if (processingIds.includes(variant.id)) {
                                    <kb-spinner class="absolute w-full h-full flex items-center justify-center" classes="w-6 h-6 fill-gray-200" />
                                }
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-template #inCartControls>
                    <div class='w-full inline-flex items-center'>
                        <input
                            class='input w-16'
                            type='number'
                            min='0'
                            max='99'
                            placeholder='Qty'
                            [ngModel]='inCartQty[variant?.id]'
                            (ngModelChange)='adjustedQty[variant?.id] = $event'
                        />
                        <div class='flex-1'></div>
                        <button
                            *ngIf='adjustedQty[variant?.id] != null'
                            [disabled]='processingIds.includes(variant.id)'
                            class='btn btn-primary bg-primary-500 px-2'
                            (click)='setQuantity(variant.id, adjustedQty[variant?.id])'
                        >
                            Update
                        </button>
                        <div class="relative">
                            <button
                                *ngIf='adjustedQty[variant?.id] == null'
                                [disabled]='processingIds.includes(variant.id)'
                                class='btn btn-primary bg-primary-500 rounded-r-none border-r-0 px-2'
                                (click)='setQuantity(variant.id, inCartQty[variant?.id] - 1)'
                            >
                                <fa-icon [icon]='minus'></fa-icon>
                            </button>
                            <button
                                *ngIf='adjustedQty[variant?.id] == null'
                                [disabled]='processingIds.includes(variant.id)'
                                class='btn btn-primary bg-primary-500 rounded-l-none px-2'
                                (click)='setQuantity(variant.id, inCartQty[variant?.id] + 1)'
                            >
                                <fa-icon [icon]='plus'></fa-icon>
                            </button>
                            @if (processingIds.includes(variant.id)) {
                                <kb-spinner class="absolute top-2 w-full flex items-center justify-center" classes="w-6 h-6 fill-gray-200" />
                            }
                        </div>
                    </div>
                </ng-template>
                <div class='w-full flex justify-between'>
                    <kb-stock-level-label [stockLevel]='variant.stockLevel'></kb-stock-level-label>
                    <button
                        class='text-sm text-gray-700 hover:text-gray-500 underline'
                        title='Colour information'
                        (click)='displayColorInfo(variant)'
                    >
                        <fa-icon [icon]='info' size='xs'></fa-icon>
                        more info
                    </button>
                </div>
            </div>
            <div class='w-full px-6 pt-4'>
                <div class='border-b border-gray-200'></div>
            </div>
        </div>

    </div>
    <div kbOnVisible (visibilityChange)='pageScrolled($event)' rootMargin='100px'></div>
</div>
